import dayjs from 'dayjs';
import z from 'zod';

export const RECEIPT_UPDATE_OPTIONS = [
  {
    value: 'on_hold_qty',
    label: 'Set exact held quantity',
  },
  {
    value: 'delta',
    label: 'Add or subtract held quantity',
  },
] as const;

export const post = {
  body: z.object({
    received_qty: z.coerce.number().min(1, { error: 'Quantity is required' }),
    expected_receipt: z.coerce.number().min(1, { error: 'Part is required' }),
    reference: z.string().optional(),
    notes: z.string().optional(),
  }),
  response: z.object({
    id: z.number(),
    part_number: z.string(),
    total_pending_qty: z.number(),
    received_by: {
      id: z.number(),
      display_name: z.string(),
    },
    created_at: z.string().refine((val) => dayjs(val).isValid()),
    updated_at: z.string().refine((val) => dayjs(val).isValid()),
    received_qty: z.number(),
    reference: z.string().optional(),
    notes: z.string().optional(),
    expected_receipt: z.number(),
  }),
  params: z.object({
    project_id: z.coerce.number(),
  }),
  query: z.never(),
};
const postSchema = z.object(post);
export type Post = z.infer<typeof postSchema>;

const get = {
  body: z.never(),
  response: z.array(
    z.object({
      id: z.number(),
      part: z.number(),
      part_number: z.string(),
      remaining_qty: z.number(),
      created_at: z.string().refine((val) => dayjs(val).isValid()), // '2026-03-02T20:12:58.587336Z'
      updated_at: z.string().refine((val) => dayjs(val).isValid()), // '2026-03-02T20:12:58.587336Z'
      received_qty: z.number(),
      total_pending_qty: z.number(),
      reference: z.string(),
      notes: z.string(),
      expected_receipt: z.number(),
      received_by: z.number(),
    }),
  ),
  params: z.object({
    project_id: z.coerce.number(),
  }),
  query: z.never(),
};
const getSchema = z.object(get);
export type Get = z.infer<typeof getSchema>;

export const patch = {
  body: z
    .object({
      received_qty: z.coerce.number(),
      reference: z.string(),
      notes: z.string(),
    })
    .partial(),
  response: z.object({
    received_qty: z.coerce.number(),
    reference: z.string(),
    notes: z.string(),
  }),
  params: z.object({
    receipt_id: z.coerce.number(),
  }),
  query: z.never(),
};
const patchSchema = z.object(patch);
export type Patch = z.infer<typeof patchSchema>;

const remove = {
  body: z.never(),
  response: z.never(),
  params: z.object({
    receipt_id: z.coerce.number(),
  }),
  query: z.never(),
};
const deleteSchema = z.object(remove);
export type Delete = z.infer<typeof deleteSchema>;
